/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Dataroom_Emptystateprospects4Inputs */

const en_coinvestments_dataroom_emptystateprospects4 = /** @type {(inputs: Coinvestments_Dataroom_Emptystateprospects4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Once you have approved prospects they'll appear here`)
};

/**
* | output |
* | --- |
* | "Once you have approved prospects they'll appear here" |
*
* @param {Coinvestments_Dataroom_Emptystateprospects4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_dataroom_emptystateprospects4 = /** @type {((inputs?: Coinvestments_Dataroom_Emptystateprospects4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Dataroom_Emptystateprospects4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_dataroom_emptystateprospects4(inputs)
});
export { coinvestments_dataroom_emptystateprospects4 as "coInvestments_dataRoom_emptyStateProspects" }